module.exports = __webpack_public_path__ + "img/1121.5dda4893.png";